import { render, staticRenderFns } from "./OperaInformationWindow.vue?vue&type=template&id=1da64821&"
import script from "./OperaInformationWindow.vue?vue&type=script&lang=js&"
export * from "./OperaInformationWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaInformationWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports